module.exports = __webpack_public_path__ + "img/section5_img2_1.5835e1bd.svg";